import React from 'react'

import { Grid, Input, SimpleCollapse, Row, CheckBox } from 'components'
import { SPACING } from 'utils'
export interface IDadosEfetivoCollapse {
  control: any
  errors: any
  disabledFunctions?: boolean
  novaAnalise?: boolean
  flStatusMoblizacao?: string
}

export interface IStatusMobilizacao {
  semMobilizacao: number
  comMobilizacao: number
  SomenteCompartilhado: number
}

const DadosEfetivoCollapse: React.FC<IDadosEfetivoCollapse> = ({
  control,
  errors,
  flStatusMoblizacao
}) => {
  const valoresStatusMobilizacao: IStatusMobilizacao = {
    SomenteCompartilhado: 2,
    comMobilizacao: 1,
    semMobilizacao: 0
  }

  return (
    <SimpleCollapse title="DADOS DO EFETIVO">
      <Grid
        gridCols="1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr"
        gridGap={`0 ${SPACING.spacing20}`}
        margin={`${SPACING.spacing10} 0 ${SPACING.spacing30} 0`}
      >
        <Input
          control={control}
          errors={errors}
          label="Ativo"
          placeholder="Ativo"
          formValue="qtAtivo"
          disabled
        />
        <Input
          control={control}
          errors={errors}
          label="Demitido"
          placeholder="Demitido"
          formValue="qtDemitido"
          disabled
        />
        <Input
          control={control}
          errors={errors}
          label="Acesso"
          placeholder="Acesso"
          formValue="qtAcesso"
          disabled
        />
        <Input
          control={control}
          errors={errors}
          label="Transferido"
          placeholder="Transferido"
          formValue="qtTransferido"
          disabled
        />
        <Input
          control={control}
          errors={errors}
          label="Afastado"
          placeholder="Afastado"
          formValue="qtAfastado"
          disabled
        />
        <Input
          control={control}
          errors={errors}
          label="Compartilhado"
          placeholder="Compartilhado"
          formValue="qtCompartilhado"
          disabled
        />
        <Input
          control={control}
          errors={errors}
          label="Total Efetivo"
          placeholder="Compartilhado"
          formValue="qtTotalEfetivo"
          disabled
        />
      </Grid>
      <Row gap={SPACING.spacing20}>
        <CheckBox
          label="Somente Compartilhado"
          onClick={null}
          checked={
            parseInt(flStatusMoblizacao) ===
            valoresStatusMobilizacao.SomenteCompartilhado
          }
          disabled
        />
        <CheckBox
          label="Com Mobilização"
          onClick={null}
          checked={
            parseInt(flStatusMoblizacao) ===
            valoresStatusMobilizacao.comMobilizacao
          }
          disabled
        />
        <CheckBox
          label="Sem Mobilização"
          onClick={null}
          checked={
            parseInt(flStatusMoblizacao) ===
            valoresStatusMobilizacao.semMobilizacao
          }
          disabled
        />
      </Row>
    </SimpleCollapse>
  )
}

export default DadosEfetivoCollapse
